import React from 'react';
import SnackBarAndAlertComponent from './snackbar-and-alert.component';

export default function SnackBarAndAlert(props) {
    return <SnackBarAndAlertComponent {...props} />;
}
